import React from "react";
import PropTypes from "prop-types";
import { Tabs, Button } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import Styles from "./Styles";
import { isEmpty } from "../../../utils/comm";

const { TabPane } = Tabs;

const SubPageConatainer = ({ setSiderOpen, page }) => {
  let sessionTabTitle = null;

  if (!isEmpty(sessionStorage.getItem("tabTitle"))) {
    sessionTabTitle = sessionStorage.getItem("tabTitle").replace(/[0-9]/g, "");
  }

  const onClickHandle = () => {
    setSiderOpen(true);
  };

  return (
    <Styles className='sub-page-container'>
      <Button className='btn-menu-open' onClick={onClickHandle} icon={<MenuOutlined />} />
      <Tabs
        type='editable-card'
        hideAdd
        className='tab-mdi'
        // onChange={onChange}
        // activeKey={activeKey}
        // onEdit={onEdit}
      >
        {/* {panes.map(pane => (
          <TabPane tab={pane.title} key={pane.key} closable={pane.closable}>
            {pane.content}
          </TabPane>
        ))} */}
        <TabPane tab={sessionTabTitle} key='1' closable={false}>
          {page}
        </TabPane>
      </Tabs>
    </Styles>
  );
};

SubPageConatainer.propTypes = {
  page: PropTypes.node,
  // setSiderOpen : PropTypes.func.isRequired,
};

SubPageConatainer.defaultProps = {
  page: null,
};

export default SubPageConatainer;
